import { isDailyBonusReady } from '../match2.util';
import { user } from '../../../../StateObserver';
import { getDailyBonusRewards } from 'src/replicant/match2/match2.getters';
import { openMatch2ChestPopup } from '../rewards/match2-rewards.utils';
import StateObserver from 'src/StateObserver';
import { shouldShowDailyBonusTosNudge } from './match2-dailybonus.utils';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import { requestMiniAppToSConsent } from 'src/lib/gcinstant';
import { Feature } from 'src/replicant/analytics';
import { track } from 'src/lib/analytics/utils';

/**
 * Open daily bonus popup.
 *
 * If the user is in the enabled bucket for TOS A/B test and meets criteria,
 * shows TOS nudge when they click the claim button.
 */
export async function openMatch2DailyBonusPopup(): Promise<void> {
  if (!isDailyBonusReady()) return;

  track('DailyBonusView', {});

  const rewards = getDailyBonusRewards(user());

  const claimed = await openMatch2ChestPopup({
    rewards,
    origin: 'hud',
    onBeforeClaim: async () => {
      track('DailyBonusCollect', {});

      if (!shouldShowDailyBonusTosNudge()) {
        return true;
      }

      // Show TOS nudge popup
      await openPopupPromise('popupDailyBonusTosNudge', {});
      track('DailyBonusPurchaseTOSNudgeContinue', {});

      // Trigger LINE TOS acceptance flow directly via LIFF SDK
      const tosAccepted = await requestMiniAppToSConsent({
        feature: Feature.MATCH2.DAILY_BONUS._,
        subFeature: Feature.MATCH2.DAILY_BONUS.TOS_NUDGE._,
      });

      return tosAccepted;
    },
  });

  if (claimed) {
    await StateObserver.invoke.collectDailyBonusRewards();
  }
}
